<template>
  <div class="modal" :class="{ 'is-active': show }">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Assign Analytics</p>
        <button
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        ></button>
      </header>

      <section class="modal-card-body">
        <!-- Boucle sur les concepts -->
        <div v-for="concept in concepts" :key="concept.id" class="box">
          <h4 class="subtitle is-6">{{ concept.name }}</h4>
          <div class="tags">
            <span
              v-for="code in concept.codes"
              :key="code.id"
              class="tag is-medium"
              :class="{
                'is-success': selectedCodes.includes(code.id),
                'is-light': !selectedCodes.includes(code.id),
                'is-clickable': true,
              }"
              @click="toggleCode(code.id)"
            >
              {{ code.label }}
            </span>
          </div>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-success" @click="save">
          <span class="icon"><i class="fas fa-save"></i></span>
          <span>Save</span>
        </button>
        <button class="button" @click="$emit('close')">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  props: {
    show: { type: Boolean, required: true },
    objectIds: { type: Array, required: true }, // Third party IDs
    scope: { type: String, required: true }, // "third_party" (here )
    endpoint: { type: String, required: true }, // "/third-parties/bulk-assign-analytics/"
  },
  data() {
    return {
      concepts: [],
      selectedCodes: [],
    };
  },
  async created() {
    // Load concepts based on scope
    if (this.scope) {
      const res = await api.get(
        `/analytics/concepts/?scope=${this.scope}&expand=codes`
      );
      this.concepts = res.data;
    }
  },
  watch: {
    show(newVal) {
      // When modal is opened, reset selected codes
      if (newVal) {
        this.selectedCodes = [];
      }
    },
  },
  methods: {
    toggleCode(codeId) {
      if (this.selectedCodes.includes(codeId)) {
        this.selectedCodes = this.selectedCodes.filter((id) => id !== codeId);
      } else {
        this.selectedCodes.push(codeId);
      }
    },
    async save() {
      if (this.selectedCodes.length === 0) {
        this.$emit('close');
        return;
      }

      let payload = {
        analytical_code_ids: this.selectedCodes,
      };

      if (this.scope === 'third_party') {
        payload.third_party_ids = this.objectIds;
      }

      if (this.scope === 'item') {
        payload.item_ids = this.objectIds;
      }

      if (this.scope === 'document') {
        payload.document_ids = this.objectIds;
      }

      await api.post(this.endpoint, payload);

      this.$emit('updated');
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.tag.is-clickable {
  cursor: pointer;
}
</style>
